export default __webpack_public_path__ + "static/media/color.55c004ad.svg";